
export const CASE_DIRECTORY = 'cases';
export const IMAGE_FIELDS = ['image', 'imageAfter'];